export default "__VITE_ASSET__BfwLAR6F__"